export default __webpack_public_path__ + "static/media/eventsvg.102b48a2.svg";